export default __webpack_public_path__ + "static/media/crossroads15.0fda9132.webp";